import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import Navbar from "./global-components/navbar-v4";
import PageHeader from "./global-components/page-header";

import CallToActionV1 from "./section-components/call-to-action-v1";
import SponsorV2 from "./section-components/sponsor-v2";
import Footer from "./global-components/footer";

class TermsConditions extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div>
        <Navbar />
        <PageHeader headertitle="Terms and Conditions of Use" />

        <div className="ltn__page-details-area ltn__service-details-area mb-105">
          <div className="container">
            <div className="row">
              <div className="">
                <div className="ltn__page-details-inner ltn__service-details-inner">
                  <h3> Effective Date: 15/10/2026</h3>
                  <p>
                    {" "}
                    These Terms and Conditions ("Agreement") govern your use of
                    the website{" "}
                    <a href="https://www.quoinmanagement.com">https://www.quoinmanagement.com</a>{" "}
                    ("Website"), the Quoin mobile application and the online
                    account platform through which tenants, leaseholders,
                    landlords and directors sign in to manage their properties
                    (the "Platform"), and the services provided by Quoin Estates Management Ltd,
                    trading as Quoin Management ("Company"), a company registered
                    in England and Wales (company no. 13185366) whose registered
                    office is at 30 Churchill Place, London E14 5RE. The Website and the Platform are
                    together referred to as the "Services". By accessing or
                    using the Services, you agree to be bound by this Agreement.
                    If you do not agree to these terms and conditions, you may
                    not use the Services.
                  </p>
                  <p>
                    {" "}
                    This Agreement governs your use of the Services only. It
                    does not replace or vary your tenancy agreement, lease,
                    transfer, management agreement or any other contract between
                    you and the Company or your landlord, freeholder or
                    residents' management company ("your Property Agreement").
                    If there is any conflict between this Agreement and your
                    Property Agreement, your Property Agreement prevails in
                    respect of your rights and obligations relating to the
                    property.
                  </p>
                  <ol>
                    <li>Definitions</li>
                    <p>
                      {" "}
                      In this Agreement the following words have the following
                      meanings:
                    </p>
                    <ol>
                      <li>
                        "Website" — the website at
                        https://www.quoinmanagement.com.
                      </li>
                      <li>
                        "Platform" — the Quoin mobile application and the online
                        account through which you sign in to view and manage
                        matters relating to your property.
                      </li>
                      <li>
                        "Services" — the Website and the Platform together.
                      </li>
                      <li>
                        "Role" — the capacity in which you hold an account:
                        tenant, leaseholder, landlord or director. You may hold
                        more than one at the same time, and your Role determines
                        what you are able to see and do.
                      </li>
                      <li>
                        "Property Agreement" — your tenancy agreement, lease,
                        transfer, management agreement or other contract
                        relating to the property, whether with us or with a
                        Client Body.
                      </li>
                      <li>
                        "Client Body" — the landlord, freeholder, residents'
                        management company or right to manage company on whose
                        behalf we manage a property.
                      </li>
                      <li>
                        "Content" — any information you submit through the
                        Services, including maintenance descriptions, enquiries,
                        messages, images and documents.
                      </li>
                    </ol>
                    <li>Acceptance of Terms</li>
                    <ol>
                      <li>
                        By accessing and using the Services, you affirm that you
                        are at least 18 years old and capable of entering into a
                        legally binding agreement.
                      </li>
                      <li>
                        You agree to comply with all applicable laws, rules, and
                        regulations while using the Services.
                      </li>
                    </ol>
                    <li>Use of the Website and the Platform</li>
                    <ol>
                      <li>
                        The Company grants you a limited, non-exclusive,
                        non-transferable, and revocable licence to access and
                        use the Services for the purpose of managing and
                        dealing with the property or properties you are
                        connected to, and for no other purpose. Where you are a
                        landlord or director, this includes use for the purposes
                        of managing your own property interests.
                      </li>
                      <li>
                        You agree not to use the Services for any unlawful or
                        prohibited activities. This includes, but is not limited
                        to, engaging in any form of illegal activity, infringing
                        intellectual property rights, transmitting harmful or
                        malicious code, or interfering with the Services'
                        functionality.
                      </li>
                      <li>
                        You further agree not to attempt to access any account,
                        property, document or record that you have not been
                        given access to, not to circumvent or attempt to
                        circumvent the Role-based restrictions that determine
                        what you can see, not to reverse engineer, decompile or
                        tamper with the Platform or its application programming
                        interfaces, not to access the Services by automated
                        means or extract data in bulk, and not to use the
                        Platform to send abusive, defamatory, discriminatory or
                        harassing content to our staff, contractors or other
                        residents.
                      </li>
                      <li>
                        The Company reserves the right to modify, suspend, or
                        discontinue any aspect of the Services at any time
                        without notice.
                      </li>
                      <li>
                        The mobile application is distributed through the Apple
                        App Store and Google Play. Your use of the application
                        is also subject to the terms of the store you obtained
                        it from, and you are responsible for any device, data
                        and network charges you incur in using it.
                      </li>
                    </ol>
                    <li>Accounts and Access</li>
                    <ol>
                      <li>
                        Accounts on the Platform are issued by the Company.
                        Access is granted on the basis of your relationship to a
                        property, and you may not create an account for anyone
                        else or on behalf of anyone else without our agreement.
                      </li>
                      <li>
                        You may hold one or more Roles — tenant, leaseholder,
                        landlord or director. What you are able to see and do in
                        the Platform, including which properties, documents,
                        charges, announcements and polls are visible to you, is
                        determined by the Roles you hold and your connection to
                        the property at the time.
                      </li>
                      <li>
                        You must keep your sign-in details confidential, must
                        not share your account with anyone else, and must tell
                        us promptly if you believe your account has been
                        accessed without your authorisation. You are responsible
                        for activity carried out under your account, except to
                        the extent it results from our failure to keep the
                        Services secure.
                      </li>
                      <li>
                        You must keep the information on your account accurate
                        and up to date, including your contact details.
                      </li>
                      <li>
                        Access may be varied, suspended or withdrawn when your
                        Role changes or ends — for example when a tenancy ends,
                        a lease is assigned, a property is sold, or a
                        directorship comes to an end.
                      </li>
                    </ol>
                    <li>Payments and Financial Information</li>
                    <ol>
                      <li>
                        Card and digital wallet payments made through the
                        Platform are processed by our payment provider, Stripe,
                        and are subject to that provider's terms. The Company
                        does not receive or store your full card details.
                      </li>
                      <li>
                        A payment is only treated as made once it has been
                        received and cleared. Balances, charges, statements and
                        reports shown in the Platform are provided for your
                        information and may not reflect payments that are still
                        in transit or transactions that have not yet been
                        processed.
                      </li>
                      <li>
                        Where there is any discrepancy between a figure shown in
                        the Platform and the underlying accounts, demands,
                        statutory notices or your Property Agreement, the latter
                        prevail.
                      </li>
                      <li>
                        Your obligation to pay rent, service charges, ground
                        rent and any other sums due under your Property
                        Agreement is unaffected by the availability of the
                        Services. If the Platform is unavailable, you remain
                        responsible for paying by another means and for meeting
                        the due dates set out in your Property Agreement, and
                        any interest, fees or recovery costs provided for in
                        that agreement continue to apply.
                      </li>
                      <li>
                        Where you purchase a service through the Platform, the
                        description and price shown at the point of purchase
                        apply. Refunds are handled in accordance with your
                        Property Agreement, the terms of the service concerned
                        and your statutory rights.
                      </li>
                    </ol>
                    <li>Maintenance and Service Requests</li>
                    <ol>
                      <li>
                        Submitting a maintenance or service request through the
                        Platform is a request only. It does not amount to
                        acceptance of the request, an admission of
                        responsibility, or an agreement to carry out or pay for
                        any work.
                      </li>
                      <li>
                        The Platform must not be used to report emergencies. If
                        there is a risk to life, health, safety or property —
                        including fire, gas leaks, flooding or a loss of power —
                        contact the emergency services, or call us on 020 8614 0767.
                      </li>
                      <li>
                        Response and repair timescales are those set out in your
                        Property Agreement and in applicable law, not those
                        implied by any status shown in the Platform.
                      </li>
                      <li>
                        Where you are responsible for the cost of works under
                        your Property Agreement, those costs may be recharged to
                        you.
                      </li>
                    </ol>
                    <li>Documents, Announcements and Polls</li>
                    <ol>
                      <li>
                        Documents, statements, certificates and reports made
                        available through the Platform are provided for your
                        information. Where you choose to email a document to
                        another address, you are responsible for the accuracy of
                        that address and for the onward handling of the
                        document.
                      </li>
                      <li>
                        Unless we expressly state otherwise, a poll or
                        consultation run through the Platform is used to gather
                        views and is not binding on the Company, the landlord,
                        the freeholder or the residents' management company, and
                        does not constitute or replace any statutory
                        consultation required by law. You may vote only in
                        polls you are eligible for, and only once.
                      </li>
                      <li>
                        Announcements, calendar events and meeting details are
                        published for the audience they are addressed to. You
                        must not forward, publish or otherwise share the content
                        of the Platform, including documents and other
                        residents' details, outside that audience except where
                        you are required or permitted to do so by law or by your
                        Property Agreement.
                      </li>
                    </ol>
                    <li>Your Content</li>
                    <ol>
                      <li>
                        You are responsible for the information and content you
                        submit through the Services, including maintenance
                        descriptions, enquiries, messages and any images or
                        documents you upload. It must be accurate, lawful, and
                        must not infringe anyone else's rights.
                      </li>
                      <li>
                        You grant the Company a non-exclusive, royalty-free
                        licence to use, store, copy and share the content you
                        submit to the extent necessary to provide the Services
                        and manage the property, including sharing it with
                        contractors, landlords, freeholders, residents'
                        management companies and their professional advisers.
                      </li>
                    </ol>

                    <li>Intellectual Property</li>
                    <ol>
                      <li>
                        The Services and their content, including but not
                        limited to text, graphics, logos, images, and software,
                        are the property of the Company or its licensors and are
                        protected by intellectual property laws.
                      </li>
                      <li>
                        You may not copy, reproduce, modify, distribute,
                        transmit, display, perform, or create derivative works
                        of any part of the Services without the prior written
                        consent of the Company.
                      </li>
                    </ol>
                    <li>Privacy Policy</li>
                    <ol>
                      <li>
                        The Company's Privacy Policy governs the collection,
                        use, and disclosure of personal information provided by
                        users of the Website and the Platform. By using the
                        Services, you consent to the collection, use, and
                        disclosure of your personal information as described in
                        the Privacy Policy.
                      </li>
                    </ol>
                    <li>Links to Third-Party Websites</li>
                    <ol>
                      <li>
                        The Services may contain links to third-party websites
                        that are not owned or controlled by the Company. The
                        Company is not responsible for the content or practices
                        of any linked third-party websites.
                      </li>
                      <li>
                        The inclusion of any third-party links on the Website or
                        in the Platform does not imply endorsement or
                        association with the linked website. Your use of any
                        third-party websites is at your own risk.
                      </li>
                    </ol>
                    <li>Availability</li>
                    <ol>
                      <li>
                        The Company does not warrant that the Services will be
                        available uninterrupted or error-free. Access may be
                        suspended for maintenance, upgrades, or for reasons
                        outside the Company's control, and features may be
                        added, changed or removed.
                      </li>
                    </ol>
                    <li>Limitation of Liability</li>
                    <ol>
                      <li>
                        Nothing in this Agreement excludes or limits the
                        Company's liability for death or personal injury caused
                        by its negligence, for fraud or fraudulent
                        misrepresentation, or for any other liability that
                        cannot lawfully be excluded or limited. If you are a
                        consumer, this Agreement does not affect your statutory
                        rights.
                      </li>
                      <li>
                        Subject to the paragraph above, the Company is not liable
                        for loss of profit, loss of business or any indirect or
                        consequential loss arising out of or in connection with your
                        use of the Services. If you are a consumer, the Company is
                        responsible for loss you suffer that is a foreseeable result
                        of its breach of this Agreement or its failure to use
                        reasonable care and skill, but not for loss that was not
                        foreseeable.
                      </li>
                      <li>
                        The Company does not warrant the accuracy, completeness,
                        or reliability of any information provided through the
                        Services. You acknowledge and agree that any reliance on
                        such information is at your own risk.
                      </li>
                    </ol>
                    <li>Indemnity</li>
                    <ol>
                      <li>
                        You agree to indemnify and hold the Company and its
                        affiliates, directors, officers, employees, and agents
                        harmless from any claims, demands, liabilities, damages,
                        losses, costs, and expenses, including reasonable legal costs, arising out of or in connection with
                        your use of the Services or any violation of this
                        Agreement. This paragraph does not apply where you are
                        acting as a consumer.
                      </li>
                    </ol>
                    <li>Modifications to the Agreement</li>
                    <ol>
                      <li>
                        The Company may update this Agreement from time to time. If
                        it makes a significant change, it will tell you by email or
                        through the Platform before the change takes effect. If you
                        do not agree to the change, you may stop using the Services.
                      </li>
                    </ol>
                    <li>Termination</li>
                    <ol>
                      <li>
                        The Company may suspend or terminate your access to the
                        Services where there is a good reason, such as a breach of
                        this Agreement or where your connection to a property comes
                        to an end.
                      </li>
                      <li>
                        Suspension or termination of your Platform access does
                        not affect your rights or obligations under your
                        Property Agreement, which continue to apply.
                      </li>
                      <li>
                        Upon termination, the provisions of this Agreement that
                        by their nature should survive termination shall remain
                        in effect.
                      </li>
                    </ol>
                    <li>Governing Law and Jurisdiction</li>
                    <ol>
                      <li>
                        This Agreement shall be governed by and construed in
                        accordance with the laws of England and Wales.
                      </li>
                      <li>
                        Any legal action or proceeding arising out of or
                        relating to this Agreement shall be brought exclusively
                        in the courts of England and Wales. If you are a
                        consumer resident in Scotland or Northern Ireland, you
                        may also bring proceedings in the courts of the country
                        in which you live.
                      </li>
                    </ol>
                    <li>Severability</li>
                    <ol>
                      <li>
                        If any provision of this Agreement is held to be
                        invalid, illegal, or unenforceable, the validity,
                        legality, and enforceability of the remaining provisions
                        shall not in any way be affected or impaired.
                      </li>
                    </ol>
                    <li>Entire Agreement</li>
                    <ol>
                      <li>
                        This Agreement constitutes the entire agreement between
                        you and the Company regarding the use of the Services
                        and supersedes any prior or contemporaneous agreements,
                        communications, and understandings, whether oral or
                        written, relating to the subject matter of this
                        Agreement. This does not affect your Property Agreement,
                        which continues in force.
                      </li>
                    </ol>
                  </ol>
                  <p>
                    By using the Services, you acknowledge that you have read,
                    understood, and agree to be bound by this Agreement. If you
                    have any questions regarding these terms and conditions,
                    please contact us at info@quoinmanagement.com.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SponsorV2 />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default TermsConditions;
